import { lazy } from 'react';

const PrintOperations = {
  Helmet: lazy(() => import('./components/Helmet')),
  Print: lazy(() => import('./containers/Print')),
  PhysicalProofs: lazy(() => import('./containers/PhysicalProofs')),
  PublicationUpload: lazy(() => import('./containers/PublicationUpload')),
};

export default PrintOperations;
